/*eslint-disable*/ export const messages = JSON.parse("{\"card.button.text\":[\"Vælg\"]}");
//# sourceMappingURL=messages.mjs.map